/**
 * Cosmetics catalog — purely visual, never affects gameplay (no pay-to-win).
 * There is NO weapon loadout: Gun Game assigns weapons. "weaponTint" is a
 * global tint applied to whatever gun the ladder hands you.
 */
export const COSMETIC_SLOTS = [
    "bodySkin",
    "headgear",
    "knifeSkin",
    "killEffect",
    "glowColor",
    "weaponTint",
];
export const COSMETICS_CATALOG = {
    bodySkin: [
        { id: "body_carbon", name: "Carbon", value: "#232733" },
        { id: "body_ivory", name: "Ivory Shell", value: "#c8ccd8" },
        { id: "body_oxide", name: "Red Oxide", value: "#7a2030" },
        { id: "body_abyss", name: "Abyss", value: "#101624" },
    ],
    headgear: [
        { id: "head_none", name: "None", value: "" },
        { id: "head_visor", name: "Visor", value: "#00f0ff" },
        { id: "head_halo", name: "Data Halo", value: "#ff2ec4" },
        { id: "head_spikes", name: "Antenna Array", value: "#9dff00" },
    ],
    knifeSkin: [
        { id: "knife_steel", name: "Steel", value: "#aab4c4" },
        { id: "knife_plasma", name: "Plasma Edge", value: "#00f0ff" },
        { id: "knife_ember", name: "Ember", value: "#ff6a00" },
        { id: "knife_void", name: "Void", value: "#6a00ff" },
    ],
    killEffect: [
        { id: "fx_shatter", name: "Shatter", value: "#00f0ff" },
        { id: "fx_pixel", name: "Pixel Burst", value: "#ff2ec4" },
        { id: "fx_ring", name: "Shockring", value: "#ffffff" },
    ],
    glowColor: [
        { id: "glow_cyan", name: "Cyan", value: "#00f0ff" },
        { id: "glow_magenta", name: "Magenta", value: "#ff2ec4" },
        { id: "glow_lime", name: "Lime", value: "#9dff00" },
        { id: "glow_amber", name: "Amber", value: "#ffb300" },
        { id: "glow_violet", name: "Violet", value: "#8a2eff" },
    ],
    weaponTint: [
        { id: "tint_stock", name: "Stock", value: "#3a4152" },
        { id: "tint_chrome", name: "Chrome", value: "#c0c8d8" },
        { id: "tint_night", name: "Nightworks", value: "#0e1220" },
        { id: "tint_synth", name: "Synthwave", value: "#ff2ec4" },
    ],
};
export const DEFAULT_COSMETICS = {
    bodySkin: "body_carbon",
    headgear: "head_none",
    knifeSkin: "knife_steel",
    killEffect: "fx_shatter",
    glowColor: "glow_cyan",
    weaponTint: "tint_stock",
};
export function isValidCosmetic(slot, id) {
    // own-property check, not truthiness: an inherited key like "constructor"
    // resolves to a function off Object.prototype — `!!items` would pass and then
    // `items.some` throws TypeError. Same guard `pickupInfo` uses (entities.ts).
    if (!Object.prototype.hasOwnProperty.call(COSMETICS_CATALOG, slot))
        return false;
    const items = COSMETICS_CATALOG[slot];
    return items.some((i) => i.id === id);
}
export function cosmeticValue(slot, id) {
    const items = COSMETICS_CATALOG[slot];
    const found = items.find((i) => i.id === id) ?? items.find((i) => i.id === DEFAULT_COSMETICS[slot]);
    return found.value;
}
//# sourceMappingURL=cosmetics.js.map